import React from 'react';
import PropTypes from 'prop-types';
import styles from './sectionRubricBlock.scss';
import { t } from '../../../services/i18nService';
import scorableItemReader from '../../../store/readHelpers/ScorableItemReader';
import scorableItemNumberingService from '../../../services/questionView/ScorableItemNumberingService';
import customFieldsService from '../../../services/CustomFieldsService';
import customFieldsConstants from '../../../constants/CustomFieldsConstants';

class SectionRubricBlock extends React.PureComponent {
    static propTypes = {
        section: PropTypes.object,
        ui: PropTypes.object,
        isPaperBased: PropTypes.bool,
    };

    returnQuestionRange() {
        const { section, ui } = this.props;
        if (scorableItemReader.useNumberPerInteraction()) {
            const { scorableItemsDash = '-' } = ui.variables;
            const firstQuestionInSection = section.questions[0];
            const lastQuestionInSection = section.questions[section.questions.length - 1];
            const firstOrderNumberInSection = scorableItemNumberingService.getFirstValidOrderNumberInQuestion(
                firstQuestionInSection.contentRevisionId
            );
            const lastOrderNumberInSection = scorableItemNumberingService.getLastValidOrderNumberInQuestion(
                lastQuestionInSection.contentRevisionId
            );
            return `${firstOrderNumberInSection}${scorableItemsDash}${lastOrderNumberInSection}`;
        }
        const firstItemNumber = section.questions[0].questionNumberingInSection;
        const lastItemNumber = section.questions[section.questions.length - 1].questionNumberingInSection;
        return `${firstItemNumber} - ${lastItemNumber}`;
    }

    returnRubricTitle(focusLevel, sectionNumber) {
        const { isPaperBased } = this.props;
        if (isPaperBased && focusLevel === customFieldsConstants.TEST_TYPE_WRITING) {
            return t('rubric.pb.title.writing', { number: sectionNumber });
        }
        return t('rubric.title.part', { number: sectionNumber });
    }

    returnRubricTitleQuestionRange(focusLevel) {
        const { isPaperBased } = this.props;
        if (isPaperBased && ![customFieldsConstants.TEST_TYPE_LISTENING, customFieldsConstants.TEST_TYPE_WRITING].includes(focusLevel)) {
            return (
                <span className={styles.sectionRubricSpacer}>
                    <i>{`${t('generic.multipleQuestionsTitle')} ${this.returnQuestionRange()}`}</i>
                </span>
            );
        }
        return null;
    }

    returnRubricInstructions(focusLevel, sectionNumber, component, isPaperBased, section) {
        const numbering = this.returnQuestionRange();
        const productFieldValue = customFieldsService.getCustomFieldValue(section?.customFields, customFieldsConstants.PRODUCT);
        if (
            isPaperBased && focusLevel === customFieldsConstants.TEST_TYPE_READING
            && (component === customFieldsConstants.COMPONENTS.IELTSACR
            || (component === customFieldsConstants.COMPONENTS.IELTSGTR && sectionNumber === 3))
        ) {
            return t('rubric.instructions.component.reading.acrOrGtr', {
                numbering,
                startPagePlaceholder: 'pages X',
                endPagePlaceholder: ' and X',
            });
        } else if (focusLevel === customFieldsConstants.TEST_TYPE_READING) {
            return t('rubric.instructions.reading', { numbering });
        } else if (focusLevel === customFieldsConstants.TEST_TYPE_LISTENING) {
            return t('rubric.instructions.listening', { numbering });
        } else if (focusLevel === customFieldsConstants.TEST_TYPE_WRITING
            && productFieldValue === customFieldsConstants.PRODUCT_GT_IOC && [1, 2].includes(sectionNumber)) {
            return t(`interactions.cscb.instructionsWriting${sectionNumber}`);
        }
        return `${t(`rubric.instructions.writing${sectionNumber}`)}`;
    }

    render() {
        const { isPaperBased, section } = this.props;
        const focusLevel = customFieldsService.getCustomFieldValue(section.customFields, customFieldsConstants.TESTING_FOCUS_LEVEL_1_FJORD);
        const isWriting = focusLevel === customFieldsConstants.TEST_TYPE_WRITING;
        const sectionNumber = customFieldsService.getCustomFieldValue(section.customFields, customFieldsConstants.SECTION);
        const component = customFieldsService.getCustomFieldValue(section.customFields, customFieldsConstants.COMPONENT);

        return (
            <section
                className={`${styles.sectionRubric} ${isPaperBased ? styles.paperBased : ''} ${isWriting ? '' : styles.italic}`}
                tabIndex={0}
                aria-labelledby={`sectionRubricTitle-${section.id} sectionRubricInstructions-${section.id}`}
                id="sectionRubric"
            >
                <h2 id={`sectionRubricTItle-${section.id}`}>
                    {this.returnRubricTitle(focusLevel, sectionNumber)}
                    {this.returnRubricTitleQuestionRange(focusLevel)}
                </h2>
                <p id={`sectionRubricInstructions-${section.id}`}>
                    {this.returnRubricInstructions(
                        focusLevel,
                        sectionNumber,
                        component,
                        isPaperBased,
                        section
                    )}
                </p>
            </section>
        );
    }
}

export default SectionRubricBlock;
